import { TripMatch } from '@marageti/z4-sdk/lib/travel';

// eslint-disable-next-line import/prefer-default-export
export const getLeadsChips = (tripMatch: TripMatch) => {
  const chips = [];

  //  Repeat Traveler
  if (tripMatch.repeatTraveler) {
    chips.push('REPEAT_TRAVELER');
  }

  // Referral Type
  if (tripMatch.referralType) {
    chips.push(tripMatch.referralType);
  }

  // Status
  if (tripMatch.status) {
    chips.push(tripMatch.status);
  }

  return chips;
};

export const getChipsFromTripMatch = (tripMatch: TripMatch) => {
  const chips = [];

  // Status
  if (tripMatch.status) {
    chips.push(tripMatch.status);
  }

  // Referral Type
  if (tripMatch.referralType) {
    chips.push(tripMatch.referralType);
  }

  //  Repeat Traveler
  if (tripMatch.repeatTraveler) {
    chips.push('REPEAT_TRAVELER');
  }

  return chips;
};
